// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.a3header_root_rSoJ2 {
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  align-items: center;
  background: white;
  border-radius: 15px;
  padding: 5px;
  white-space: nowrap;
  overflow: hidden;
  font-size: 28px;
  height: 87px;
}

.a3header_infoContainer_G3JXi {
  display: flex;
}

.a3header_zone_u8kkJ {
  display: flex;
  flex-direction: column;
  height: 0px;
  color: var(--background);
  background: white;
  align-items: center;
}

.a3header_zoneHeading_Uxwm8 {
  display: flex;
  color: black;
  font-size: 15px;
  font-family: GothamRounded-Medium;
  color: var(--timetable-text-color);
}
.a3header_zoneLetter_CHoBR {
  display: flex;
  color: black;
  font-size: 1.9em;
  font-family: GothamRounded-Medium;
  width: 60px;
  height: 60px;
  color: rgb(255 255 255);
  background: var(--timetable-text-color);
  border-radius: 50%;
  justify-content: space-evenly;
}

.a3header_routesContainer_Rf2gL {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.a3header_group_R67XX {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.a3header_destinations_gncyI {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.a3header_id_YMss0 {
  padding: 0 12px;
  font-family: GothamXNarrow-Medium;
  font-size: 1.2em;
}

.a3header_simple_A7heX .a3header_id_YMss0 {
  font-size: 0.83em;
  padding: 0 0.25em 0 0;
  font-family: GothamXNarrow-Medium;
}

.a3header_stopTitleContainer_rBwVI {
  padding-right: 20px;
}

.a3header_stopTitle_c3vsN {
  font-size: 1em;
  color: var(--timetable-text-color);
  font-family: GothamRounded-Book;
}

.a3header_stopIdContainer_Kkue9 {
  display: flex;
  flex-flow: column;
  align-items: center;
  max-height: 100%;
  padding-right: 5px;
}

.a3header_stopIdTitle__yUeL {
  font-size: 10px;
  color: var(--timetable-text-color);
  font-family: GothamRounded-Medium;
}

.a3header_stopId_njCz5 {
  color: var(--timetable-text-color);
  margin-top: 5px;
  padding: 0 20px;
  font-size: 0.75em;
  text-align: center;
  border: 5px solid var(--timetable-text-color);
  border-radius: 10px;
  font-family: GothamRounded-Medium;
}

.a3header_simplestRoutes_A2SFq {
  font-size: 0.73em;
  display: flex;
  flex-wrap: wrap;
  width: auto;
  white-space: normal;
  padding: 10px 50px 10px 50px;
  color: var(--timetable-text-color);
}

.a3header_title_YttXB {
  padding-right: 0.893em;
  font-family: GothamXNarrow-Medium;
  font-size: 0.63em;
}

.a3header_simple_A7heX .a3header_title_YttXB {
  padding-right: 0.25em;
}

.a3header_subtitle_cCzek {
  font-family: GothamXNarrow-Book;
}
`, "",{"version":3,"sources":["webpack://./src/components/a3stopPoster/a3header.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,iCAAiC;EACjC,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,uCAAuC;EACvC,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,6CAA6C;EAC7C,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EAEE,+BAA+B;AACjC","sourcesContent":[".root {\n  display: flex;\n  flex-shrink: 0;\n  justify-content: space-between;\n  align-items: center;\n  background: white;\n  border-radius: 15px;\n  padding: 5px;\n  white-space: nowrap;\n  overflow: hidden;\n  font-size: 28px;\n  height: 87px;\n}\n\n.infoContainer {\n  display: flex;\n}\n\n.zone {\n  display: flex;\n  flex-direction: column;\n  height: 0px;\n  color: var(--background);\n  background: white;\n  align-items: center;\n}\n\n.zoneHeading {\n  display: flex;\n  color: black;\n  font-size: 15px;\n  font-family: GothamRounded-Medium;\n  color: var(--timetable-text-color);\n}\n.zoneLetter {\n  display: flex;\n  color: black;\n  font-size: 1.9em;\n  font-family: GothamRounded-Medium;\n  width: 60px;\n  height: 60px;\n  color: rgb(255 255 255);\n  background: var(--timetable-text-color);\n  border-radius: 50%;\n  justify-content: space-evenly;\n}\n\n.routesContainer {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n.group {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n\n.destinations {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.id {\n  padding: 0 12px;\n  font-family: GothamXNarrow-Medium;\n  font-size: 1.2em;\n}\n\n.simple .id {\n  font-size: 0.83em;\n  padding: 0 0.25em 0 0;\n  font-family: GothamXNarrow-Medium;\n}\n\n.stopTitleContainer {\n  padding-right: 20px;\n}\n\n.stopTitle {\n  font-size: 1em;\n  color: var(--timetable-text-color);\n  font-family: GothamRounded-Book;\n}\n\n.stopIdContainer {\n  display: flex;\n  flex-flow: column;\n  align-items: center;\n  max-height: 100%;\n  padding-right: 5px;\n}\n\n.stopIdTitle {\n  font-size: 10px;\n  color: var(--timetable-text-color);\n  font-family: GothamRounded-Medium;\n}\n\n.stopId {\n  color: var(--timetable-text-color);\n  margin-top: 5px;\n  padding: 0 20px;\n  font-size: 0.75em;\n  text-align: center;\n  border: 5px solid var(--timetable-text-color);\n  border-radius: 10px;\n  font-family: GothamRounded-Medium;\n}\n\n.simplestRoutes {\n  font-size: 0.73em;\n  display: flex;\n  flex-wrap: wrap;\n  width: auto;\n  white-space: normal;\n  padding: 10px 50px 10px 50px;\n  color: var(--timetable-text-color);\n}\n\n.title {\n  padding-right: 0.893em;\n  font-family: GothamXNarrow-Medium;\n  font-size: 0.63em;\n}\n\n.simple .title {\n  padding-right: 0.25em;\n}\n\n.subtitle {\n  composes: title;\n  font-family: GothamXNarrow-Book;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `a3header_root_rSoJ2`,
	"infoContainer": `a3header_infoContainer_G3JXi`,
	"zone": `a3header_zone_u8kkJ`,
	"zoneHeading": `a3header_zoneHeading_Uxwm8`,
	"zoneLetter": `a3header_zoneLetter_CHoBR`,
	"routesContainer": `a3header_routesContainer_Rf2gL`,
	"group": `a3header_group_R67XX`,
	"destinations": `a3header_destinations_gncyI`,
	"id": `a3header_id_YMss0`,
	"simple": `a3header_simple_A7heX`,
	"stopTitleContainer": `a3header_stopTitleContainer_rBwVI`,
	"stopTitle": `a3header_stopTitle_c3vsN`,
	"stopIdContainer": `a3header_stopIdContainer_Kkue9`,
	"stopIdTitle": `a3header_stopIdTitle__yUeL`,
	"stopId": `a3header_stopId_njCz5`,
	"simplestRoutes": `a3header_simplestRoutes_A2SFq`,
	"title": `a3header_title_YttXB`,
	"subtitle": `a3header_subtitle_cCzek a3header_title_YttXB`
};
module.exports = ___CSS_LOADER_EXPORT___;
